import { useState, useRef } from "react";
import { useVarietyPricingsPaged } from "../hooks/useVarietyPricings";
import { CreateVarietyPricingDialog } from "../components/varietyPricing/CreateVarietyPricingDialog";
import { VarietyPricingsTable } from "../components/varietyPricing/VarietyPricingsTable";
import { LoadingAnimation } from "@/shared/components/LoadingAnimation";

export const VarietyPricingManagement = () => {
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const { data: page, isLoading, isFetching, error } = useVarietyPricingsPaged({
    pageNumber,
    pageSize,
    search: search || undefined,
  });

  const handleSearchChange = (value: string) => {
    setSearchInput(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSearch(value);
      setPageNumber(1);
    }, 300);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setPageNumber(1);
  };

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load variety pricings</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            Variety Pricing
          </h1>
          <p className="text-gray-500 mt-1">
            Manage seedling and service pricing for varieties
          </p>
        </div>
        <CreateVarietyPricingDialog />
      </div>

      <VarietyPricingsTable
        varietyPricings={page?.items ?? []}
        totalCount={page?.totalCount ?? 0}
        totalPages={page?.totalPages ?? 1}
        search={searchInput}
        onSearchChange={handleSearchChange}
        pageNumber={pageNumber}
        pageSize={pageSize}
        onPageChange={setPageNumber}
        onPageSizeChange={handlePageSizeChange}
        isFetching={isFetching}
      />
    </div>
  );
};